import { render, staticRenderFns } from "./TepAsignacionesPresupuestalesForm.vue?vue&type=template&id=b223cb08"
import script from "./TepAsignacionesPresupuestalesForm.vue?vue&type=script&lang=js"
export * from "./TepAsignacionesPresupuestalesForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports